import actionTypes from '../../../../../../actions/Ui/Views/Admin/Variable/Deletor/actionTypes';

const initialState = {
  isDeleting: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.DELETING:
      return {
        ...state,
        isDeleting: true,
      };
    case actionTypes.DELETED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
